import { AnyConceptStatusesByCid, FusionError, safeParseJson, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	getConceptStatusValue,
	PhysicianListConcept,
	RPhysician,
} from "@fusion-advantage/formlib"
import { FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import _ from 'lodash'

export class PhysicianListModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const jValue = getConceptStatusValue(statusesByCid[PhysicianListConcept.cid])
		if(!jValue) {
			return ok()
		}
		if(!_.isString(jValue)) {
			return err(serializeFusionError('PhysicianListModelReduxPersister', 'expected null or string, got something else'))
		}
		const rParse = safeParseJson(jValue, z.array(RPhysician))
		if(rParse.isErr()) {
			return err(serializeFusionError('PhysicianListModelReduxPersister rParse', rParse.error))
		}
		// no persistence from here;
		// currently uses legacy L4TabularState
		return ok()
	}
	shouldSave(): boolean {
		return false
	}
	createStatusUpdates(): ConceptStatusUpdate[] {
		return []
	}
}
